import { faSteamSymbol } from '@fortawesome/free-brands-svg-icons';
import {
  faInfoCircle,
  faGamepad,
  faXmark,
  faCircleCheck,
  faPlusCircle,
  faThumbsUp,
  faMemo,
  faBoxOpen,
  faCubesStacked,
  faCalendarDays,
  faCaretDown,
  faLayerPlus,
  faBuilding,
  faCircleXmark,
  faBan,
  faBlockQuestion,
  faDownload,
  faFilterSlash,
  faCloudArrowDown,
  faFilter,
  faEnvelopeOpenText,
  faGrid,
  faGridDividers,
  faKey,
  faTrophy,
  faUserPlus,
  faExchange,
  faMoneyBillWave,
  faList,
  faMagnifyingGlass,
  faUserShield,
  faLoader,
  faUserPen,
  faCopy,
  faGear,
  faHourglassClock,
  faSlidersH,
  faArrowUp,
  faArrowDown,
  faTag,
  faGlobeAmericas,
  faUpload,
  faUserTag,
  faUser,
  faUsers,
  faExclamationTriangle,
  faRotateLeft,
  faStar,
  faWaveSquare,
  faBalanceScale,
  faArrowsRotate,
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowTurnDownLeft,
  faEye,
  faFile,
  faLink,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faSkull,
  faCalendarXmark,
  faTriangleExclamation,
  faTimes,
  faPencil,
  faSearch,
  faEnvelope,
  faCalendarCheck,
  faCalendarTimes,
  faBolt,
  faArrowRight,
  faRotateRight,
  faTerminal,
  faSatelliteDish,
  faDatabase
  //@ts-ignore
} from '@fortawesome/pro-solid-svg-icons';
import {
  faPersonDollyEmpty,
  faShoppingCart,
  faStore,
} from '@fortawesome/pro-thin-svg-icons';
import {
  faBell,
  faHeart,
  faListDropdown,
  faSparkles,
} from '@fortawesome/sharp-light-svg-icons';
import {
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClockRotateLeft,
  faEllipsis,
  faEllipsisVertical,
  faExternalLinkAlt,
  faFileUpload,
  faListUl,
  faLock,
  faRightLeft,
  faTrash,
  faXmark as faXmarkSharpRegular,
} from '@fortawesome/sharp-regular-svg-icons';
import {
  faGripDotsVertical,
  faPlus,
  faSpinnerThird,
} from '@fortawesome/sharp-solid-svg-icons';

const icons = {
  ACCORDIAN_CLOSED: faChevronDown,
  ACCORDIAN_OPENED: faChevronUp,
  ADD: faPlusCircle,
  ALLOW: faPlusCircle,
  ANNOUNCEMENT: faBell,
  APP_ID: faMemo,
  APPROVE_REQUESTS: faThumbsUp,
  APPROVE: faCircleCheck,
  ARCHIVED: faSkull,
  ARE_YOU_SURE: faTriangleExclamation,
  AUDIT: faClockRotateLeft,
  BALANCE_SCALE: faBalanceScale,
  BASKET: faShoppingCart,
  BATCHES: faBoxOpen,
  BULK_REQUEST: faCubesStacked,
  CALENDAR: faCalendarDays,
  CARET_DOWN: faCaretDown,
  CHANGE_STATUS: faLayerPlus,
  CHEVRON_LEFT: faChevronLeft,
  CHEVRON_RIGHT: faChevronRight,
  CLOSE: faTimes,
  COMPANY: faBuilding,
  CONFIRM_REQUEST: faCheck,
  CUBES_STACKED: faCubesStacked,
  DECLINE: faCircleXmark,
  DELETE_TAG: faXmarkSharpRegular,
  DELETE: faXmarkSharpRegular,
  DISABLE_KEYS: faTrash,
  DISABLED_REASON: faBlockQuestion,
  DISABLED: faBan,
  DISALLOW: faXmark,
  DOWNLOAD_ALL_DATA: faFilterSlash,
  DOWNLOAD_DATA: faCloudArrowDown,
  DOWNLOAD_FILTERED_DATA: faFilter,
  DOWNLOAD_KEYS: faDownload,
  DOWNLOAD: faDownload,
  DOWNLOADED: faDownload,
  DROPDOWN_TOGGLE: faEllipsisVertical,
  EDIT: faPencil,
  EMAIL_LOGS: faEnvelopeOpenText,
  FAILED: faXmark,
  FILE: faFile,
  GAME_LICENSE_EXPIRED: faCalendarXmark,
  GAME: faGamepad,
  GAME_FRANCHISE: faStore,
  GRID_DIVIDER: faGridDividers,
  GRID: faGrid,
  INFO: faInfoCircle,
  INSIGHTS: faSparkles,
  KEBAB_MENU_VERTICAL: faEllipsisVertical,
  KEBAB_MENU: faEllipsis,
  KEY_ACTIVATED: faTrophy,
  KEY_ALLOCATED: faUserPlus,
  KEY_AVAILABLE: faKey,
  KEY_DISABLED: faBan,
  KEY_MOVED: faExchange,
  KEY_POOL: faKey,
  KEY_PROVIDER: faKey,
  KEY_SOLD: faMoneyBillWave,
  KEYS: faKey,
  LICENSE_EXPIRED: faCalendarXmark,
  LINK_EXTERNAL: faExternalLinkAlt,
  LINK_INTERNAL: faExternalLinkAlt,
  LINK: faLink,
  LIST: faList,
  LOCKED: faLock,
  MAGNIFYING_GLASS: faMagnifyingGlass,
  MOVE_KEYS: faRightLeft,
  MOVED: faExchange,
  NO: faXmark,
  NOTHING_TO_SHOW: faPersonDollyEmpty,
  NOTIFICATION: faBell,
  PACKAGE_TYPE: faBoxOpen,
  PERMISSIONS: faUserShield,
  PERSONALISATION: faHeart,
  PLATFORM: faGamepad,
  PLUS: faPlus,
  PRICING: faMoneyBillWave,
  PROCESS_SELECTION: faLoader,
  PROMOTION: faLoader,
  REASSIGN: faUserPen,
  REPLENISH: faArrowsRotate,
  REPORT: faFile,
  REQUEST_AGAIN: faCopy,
  REQUEST_KEYS: faKey,
  REQUEST_ON_STEAM: faSteamSymbol,
  REQUESTS: faShoppingCart,
  RETRY: faLock,
  RETURN_KEYS: faArrowTurnDownLeft,
  SEARCH: faSearch,
  SEND_EMAILS: faEnvelope,
  SET_KEYS_ORDERED: faHourglassClock,
  SET_STATUS: faThumbsUp,
  SETTINGS: faGear,
  SKU_LICENSE_EXPIRED: faCalendarXmark,
  SKU: faGamepad,
  SLA_BREACHED: faCalendarTimes,
  SLA: faCalendarCheck,
  SLIDERS: faSlidersH,
  SOLD: faMoneyBillWave,
  SORT_ASC: faArrowUp,
  SORT_DESC: faArrowDown,
  SORTABLE_HANDLE: faGripDotsVertical,
  SPINNER: faSpinnerThird,
  SUCCESS: faCircleCheck,
  TABLE_BULK: faListUl,
  TABLE_GROUPED: faListDropdown,
  TABLE_SETTINGS: faGear,
  TABLE_UNGROUPED: faList,
  TAG: faTag,
  TERRITORIES: faGlobeAmericas,
  UPLOAD_ACCOUNT_DETAILS: faUserPlus,
  UPLOAD_KEYS: faFileUpload,
  UPLOAD: faUpload,
  UPLOADERS: faUserTag,
  USER_PERMISSIONS: faUsers,
  USER: faUser,
  USERS: faUsers,
  VIEW: faEye,
  WARNING: faExclamationTriangle,
  WITHDRAW_REQUEST: faRotateLeft,
  WIZARD_NEXT: faChevronRight,
  WIZARD_STAR: faStar,
  WORKFLOW: faWaveSquare,
  YES: faCheck,

  STEAM: faSteamSymbol,
  BOLT: faBolt,
  CIRCLE_CHECK: faCircleCheck,
  CLOUD_ARROW_DOWN: faCloudArrowDown,
   ARROW_RIGHT: faArrowRight,
   ROTATE_RIGHT: faRotateRight,
   TERMINAL: faTerminal,
   CHECK: faCheck,
   LIST_CHECK: faListUl,
   CHECK_DOUBLE: faCheck,
   SATELLITE_DISH: faSatelliteDish,
   DATABASE: faDatabase
} as const;

export default icons;
